import emitter from 'tiny-emitter/instance';

export const eventBus = {
    $on: function (...args) {
        const events = Array.isArray(args[0]) ? args[0] : [args[0]];
        events.forEach((event) => emitter.on(event, ...args.slice(1)));
    },
    $once: (...args) => emitter.once(...args),
    $off: function (...args) {
        const events = Array.isArray(args[0]) ? args[0] : [args[0]];
        events.forEach((event) => emitter.off(event, ...args.slice(1)));
    },
    $emit: function (...args) {
        let lastArg = args[args.length - 1];
        let timeout = typeof lastArg === 'object' && lastArg.hasOwnProperty('timeout') ? lastArg.timeout : 0;

        setTimeout(() => {
            emitter.emit(...args);
        }, timeout);
    },
};

setInterval(() => {
    const isActiveTab = (document.hasFocus && document.hasFocus()) ?? false;

    if (isActiveTab) {
        eventBus.$emit(events.clockUpdated, Math.floor(new Date().getTime() / 1000));
    }
}, 1000);

export const events = {
    assetOperabilityUpdated: 'asset.operability.updated', // { asset: String, operability: String, reason: String }
    assetUsageCategoryUpdated: 'asset.usage.category.updated', // { asset: String, usageCategory: String }
    cancelConfirmAssetStatusChangeModal: 'cancel.confirm.asset.status.change.modal',
    clockUpdated: 'clock.updated',
    dashboardWidgetRefresh: 'dashboard.widget.refresh', // Trigger widgets to refresh their data
    editPerformanceDataItem: 'edit.performance.data.item',
    openAssetStatusChangePrompt: 'open.asset.status.change.prompt',
    openAttachmentListModal: 'open.attachment.list.modal',
    openBlockedOperabilityChangeModal: 'open.blocked.operability.change.modal', // { workOrders: Array }
    openConfirmAssetStatusChangeModal: 'open.confirm.asset.status.change.modal',
    openConfirmAssetUsageCategoryChangeModal: 'open.confirm.asset.usage.category.change.modal',
    openConfirmDeleteStakeholderModal: 'open.confirm.delete.stakeholder.modal',
    openConfirmDiscardChangesModal: 'open.confirm.discard.changes.modal',
    openCreateMaintainerModal: 'open.create.maintainer.modal',
    openCreateMaintainerServiceLevelAgreementModal: 'open.create.maintainer.service.level.agreement.modal',
    openCreateOperatorModal: 'open.create.operator.modal',
    openCreateOwnerModal: 'open.create.owner.modal',
    openCreatePerformanceDataModal: 'open.create.performance.data.modal',
    openCreateSpecificLocationModal: 'open.create.specific.location.modal',
    openCreateStatusCheckModal: 'open.create.status.check.modal',
    openDeleteLocationModal: 'open.delete.location.modal',
    openDeleteWorkOrderModal: 'open.delete.work.order.modal',
    openEditMaintainerModal: 'open.edit.maintainer.modal',
    openEditOperatorModal: 'open.edit.operator.modal',
    openEditOwnerModal: 'open.edit.owner.modal',
    openInoperableTestBlockedModal: 'open.inoperable.test.blocked.modal',
    openQrCodeScanner: 'open.qr.code.scanner', // { assetId: String, type: String, onSuccessfulScan: () => void }
    openQualityAssuranceConfigurationModal: 'open.quality.assurance.configuration.modal',
    openTaskModal: 'open.task.modal',
    openTestRecordsModal: 'open.test.records.modal',
    openUnsavedChangesModal: 'open.unsaved.changes.modal',
    openUpdateCadenceConfigModal: 'open.update.cadence.config.modal',
    performedAssetStatusCheck: 'performed.asset.status.check',
    hideStickyBanner: 'sticky.banner.hide',
    presentFlashMessage: 'present.flash.message',
    showStickyBanner: 'sticky.banner.show',
    taskApproved: 'task.approved',
    updateNotifications: 'notifications.update',
    workOrderCreated: 'workorder.created',
    workOrderDeleted: 'workorder.deleted',
    workOrderStatusUpdated: 'workorder.status.updated', // { workOrderId: String, status: String }
    workOrderUpdated: 'workorder.updated',
};
